export default {"src":"/_next/static/media/business10.5df57f0c.svg","height":72,"width":72,"blurWidth":0,"blurHeight":0};